import { format } from "date-fns";
import React from "react";

import {
  Box,
  VStack,
  Text,
  HStack,
} from "@whoosh/design-system/src/components/primitive";
import {
  generateCalendarDayHeader,
  NumericalDayOfWeek,
} from "@whoosh/utilities/src/calendars";

export const MonthHeader = ({
  monthDateObj,
  clubWeekStartsOn,
}: {
  monthDateObj: Date;
  clubWeekStartsOn: NumericalDayOfWeek;
}) => {
  const monthName = format(monthDateObj, "MMMM");
  const dayNames = generateCalendarDayHeader(clubWeekStartsOn);
  return (
    <VStack pb={5}>
      <Box alignItems="center" justifyContent="center" pb={5}>
        <Text maxFontSizeMultiplier={2} fontSize={16} fontWeight="bold">
          {monthName}
        </Text>
      </Box>
      <HStack>
        {dayNames.map((name) => {
          return (
            <Box
              alignItems="center"
              justifyContent="center"
              key={name}
              flex={1}
            >
              <Text
                maxFontSizeMultiplier={2}
                color="text-secondary"
                fontFamily="Inter_600SemiBold"
                fontSize={11}
                fontWeight="normal"
              >
                {name}
              </Text>
            </Box>
          );
        })}
      </HStack>
    </VStack>
  );
};
